import { registerWorkflowProduct } from "src/views/products/workflow/registry";

/**
 * The Parts Sourcing product. productKey activates the lead persona
 * resolver server-side; licenseModule stays "parts-ai" (no new entitlement).
 */
export const PARTS_SOURCING_PRODUCT = registerWorkflowProduct({
  productKey: "parts-sourcing",
  licenseModule: "parts-ai",
  displayName: "Parts Sourcing",
  basePath: "/parts/search",
  streamKey: "parts-sourcing",
  testIdPrefix: "psrc",
  leadSlotKey: "lead",
  buildChatUrlForDialogue: () => async (dialogueId: number) =>
    `/parts/chat/search/${dialogueId}`,
});
